import React from 'react';
import { Spinner } from 'react-bootstrap';
import { FaMobileAlt } from 'react-icons/fa';
import { LARGURA_ARTE, ALTURA_ARTE } from '../constants';

// Preview visual (HTML/CSS) reproduzindo as posições do CSS legado (Layout/css/Assinatura.css).
// A imagem final é gerada no backend; pode haver pequena diferença visual — aceitável.
const PreviewAssinatura = ({
  arteUrl,
  carregando,
  nome,
  departamento,
  mostrarContato,
  ddd,
  numero,
}) => (
  <div style={{ overflowX: 'auto' }}>
    <div
      style={{
        position: 'relative',
        width: LARGURA_ARTE,
        height: ALTURA_ARTE,
        margin: '0 auto',
        backgroundColor: '#f3f3f3',
        fontFamily: "'Noto Sans', sans-serif",
      }}
    >
      {carregando ? (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Spinner animation="border" size="sm" /> <span>Carregando arte...</span>
        </div>
      ) : arteUrl ? (
        <img
          src={arteUrl}
          alt="Arte da assinatura"
          width={LARGURA_ARTE}
          height={ALTURA_ARTE}
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
      ) : null}

      {/* Nome | Departamento (CSS .areaNome: top 10, left 34) */}
      <div
        style={{
          position: 'absolute',
          top: 10,
          left: 34,
          color: '#fff',
          whiteSpace: 'nowrap',
        }}
      >
        <span style={{ fontWeight: 'bold', fontSize: 21 }}>{nome}</span>
        {nome && departamento ? (
          <span style={{ fontWeight: 'bold', fontSize: 21 }}>{'  •'}</span>
        ) : null}
        <span
          style={{
            fontWeight: 'bold',
            fontSize: 19,
            color: '#1B3E82',
            marginLeft: nome && departamento ? 12 : 0,
          }}
        >
          {departamento}
        </span>
      </div>

      {/* Contato (telefone + ícone) — canto superior direito da faixa azul, alinhado ao nome. */}
      {mostrarContato && (ddd || numero) ? (
        <div
          style={{
            position: 'absolute',
            top: 12,
            right: 35,
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: 20,
          }}
        >
          <FaMobileAlt size={18} style={{ marginRight: 6 }} />
          <span style={{ whiteSpace: 'nowrap' }}>
            {ddd ? `(${ddd}) ` : ''}
            {numero}
          </span>
        </div>
      ) : null}
    </div>
  </div>
);

export default PreviewAssinatura;
